import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path, token) => {
  if (!path) return null;
  const t = token || "";
  return `${API}/files/${path}${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
};
